import { Component, OnInit, AfterViewInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
    selector: 'cp-search-input',
    templateUrl: './cp-search-input.component.html',
    styleUrls: ['./cp-search-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CPSearchInputComponent implements OnInit, AfterViewInit {
    constructor(private cd: ChangeDetectorRef) {

    }
    @ViewChild("searchBox") inputBox: ElementRef;
  //  protected _searchBox: ElementRef;
    protected searchUpdate: Subject<string> = new Subject();
    svalue: string;
    @Input() searchText: string = "";
    subs: Subscription;
    @Input() minSearchSize: number = 3;
    @Input() dbTime: number = 500;
    @Output() search: EventEmitter<string> = new EventEmitter<string>();  // This is an output component that tells the rest of the world that the user has entered a valid text
    ngOnInit() {
  //  this._searchBox = this.inputBox;
    }
    ngAfterViewInit() {
        //console
//        this.cd.detectChanges();
        setTimeout(() => { // this will make the execution after the above boolean has changed
            this.inputBox.nativeElement.focus();
        }, 0);  
        //if (this._searchBox) {
        //    this._searchBox.nativeElement.focus();
        //}
        this.searchUpdate.asObservable().pipe(debounceTime(this.dbTime)).pipe(distinctUntilChanged()).subscribe(data => {
            this.search.emit(data);
        });
    }
    public onSearchType(value: string, e: any) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        else {
            this.searchUpdate.next(value); // Emit the event to all listeners that signed up - we will sign up in our contractor
        }
    }
    clear() {
        this.searchText = "";
    }
    setValue(value : string) {
        this.searchText = value;
       // this.svalue = value;
    }

}
